<div
    class="container-piece-seo"
    *ngIf="{
        isRtl: isRtl$ | async
    } as pieceSeoData"
>
    <!--style="--background-color: {{ backgroundColor }}; --text-color: {{ textColor }}"-->
    <ng-container *ngTemplateOutlet="categoriesList"></ng-container>
    <ng-template #categoriesList>
        <ng-container *ngIf="(categories$ | async)?.length > 0">
            <div class="bg-piece-seo" [class.is-rtl]="pieceSeoData.isRtl">
                <div class="arrow-left cursor-pointer" (click)="scrollStart()" [style.opacity]="opacityArrowStart">
                    <svg-icon src="chevron-left{{ isLightTextColor ? '-light' : '' }}"></svg-icon>
                </div>
                <div class="piece-seo-block">
                    <div class="text-piece-seo footer-goto">
                        <div class="footer-goto-label" *ngIf="!!textLeft">
                            <span class="text-l">{{ textLeft }}</span>
                        </div>
                        <div class="piece-seo-grandient-start" [style.opacity]="opacityGrandientStart"></div>
                        <ul
                            class="footer-goto-list list-inline ov-scroll text-l"
                            (scroll)="onScroll($event, pieceSeoData.isRtl)"
                            #divContainer
                            [class.no-left-text]="!textLeft"
                        >
                            <li class="footer-goto-list-item text-l" *ngFor="let category of categories$ | async; index as i; trackBy: trackByIndex">
                                <render-link [link]="category" [styleClass]="'link-raw has-ellipsis'" [element]="element">
                                    {{ category.name }}
                                </render-link>
                            </li>
                        </ul>
                        <div class="piece-seo-grandient-end" [style.opacity]="opacityGrandientEnd"></div>
                    </div>
                </div>
                <div class="arrow-right cursor-pointer" (click)="scrollEnd()" [style.opacity]="opacityArrowEnd">
                    <svg-icon src="chevron-right{{ isLightTextColor ? '-light' : '' }}"></svg-icon>
                </div>
            </div>
        </ng-container>
    </ng-template>
</div>
